export default function Location() {
  return (
    <section id="location" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Our Location
          </h2>
          <p className="text-gray-600 text-base max-w-2xl mx-auto">
            Conveniently located in Islamkot, easy to find and access
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-start">
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Find Us Here</h3>
            <div className="space-y-4">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0 mr-4">
                  <i className="ri-map-pin-line text-emerald-600 text-xl w-5 h-5 flex items-center justify-center"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Address</h4>
                  <p className="text-gray-600 text-sm">Islamkot, Sindh, Pakistan</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0 mr-4">
                  <i className="ri-phone-line text-emerald-600 text-xl w-5 h-5 flex items-center justify-center"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Phone</h4>
                  <p className="text-gray-600 text-sm">Contact us for reservations</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0 mr-4">
                  <i className="ri-time-line text-emerald-600 text-xl w-5 h-5 flex items-center justify-center"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Check-in / Check-out</h4>
                  <p className="text-gray-600 text-sm">Check-in: 2:00 PM | Check-out: 12:00 PM</p>
                </div>
              </div>
            </div>

            <div className="mt-8">
              <a
                href="https://maps.app.goo.gl/BkJoSiXh2hQA9Qcd8"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-6 py-3 bg-emerald-600 text-white rounded-lg font-medium hover:bg-emerald-700 transition-colors whitespace-nowrap"
              >
                <i className="ri-map-pin-line mr-2 w-5 h-5 flex items-center justify-center"></i>
                View on Google Maps
              </a>
            </div>
          </div>

          <div className="relative h-96 w-full rounded-lg overflow-hidden shadow-lg">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3515.8234567890123!2d70.1866595!3d24.6985924!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x394f930074cbf9af%3A0x9d9df7597b40d7e2!2sSerene%20guest%20house%20Islamkot!5e0!3m2!1sen!2s!4v1234567890123!5m2!1sen!2s"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Serene Guest House Location"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}
